const commonErrorMessage = {
  MSE00002: (item_name: string) => `${item_name}を選択してください。`,
  MSE00003: (item_name: string) => `${item_name}を入力してください。`,

  CREATE_SUCCESS: '登録しました。',
  UPDATE_SUCCESS: '編集しました。',
  DELETE_SUCCESS: (item_name: string) => `${item_name}しました。`,

  MSE_SYSTEM: 'サーバーでエラーが発生しました。管理者に問い合わせてください。',
  UNKNOWN_ERROR_MESSAGE: '失敗した',
};

export { commonErrorMessage };
